<template>
    <el-drawer class="fst-FeedbackForm"
               :title="$t('label.leaveFeedback')"
               :visible.sync="show"
               :append-to-body="true"
               :modal-append-to-body="true"
               :destroy-on-close="true"
               size="600px"
               direction="rtl">
        <div>
            <user-feedback ref="feedback" @showUserFeedback="close()" :msgType="type"></user-feedback>
        </div>
    </el-drawer>
</template>

<script>
    import UserFeedback from '@/commons/components/UserFeedbackForm';

    export default {
        name: "FeedbackForm",
        components: {UserFeedback},
        data() {
            return {
                show: false,
                type: '',
            }
        },
        watch: {
            show(status){
                if(!status){
                    this.$refs.feedback.reset()
                }
            }
        },
        methods: {
            close() {
                this.show = false;
            }
        }
    }
</script>

<style lang="scss">
    .fst-FeedbackForm {
        .el-drawer__header {
            padding: 10px 15px;
            background: $iq-color-primary;
            color: #fff;
            font-weight: 500;
            font-size: 18px;
            margin-bottom: 0;
        }

    }
</style>